/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'authoritys': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M945.193 197.457s-89.718-5.776-136.622-48.527c-49.028-44.781-55.337-126.598-55.337-126.598S631.32.347 507.284.347C385.4.347 261.331 22.33 261.331 22.33s-8.275 82.285-54.805 124.786c-49.34 45.06-137.152 50.34-137.152 50.34s-9.4 160.447 4.027 299.755c13.24 137.123 47.154 272.653 172.97 375.36 102.866 84.003 256.819 151.081 256.819 151.081s120.883-52.712 208.446-110.046c96.213-63.207 186.71-149.489 214.41-313.78 29.295-173.782 19.146-402.37 19.146-402.37zM676.352 844.468c-58.143 38.027-134.038 73.675-161.793 86.294v-422.18H148.866c-.31-2.945-.606-5.891-.89-8.838-11.148-115.387-3.342-248.138-3.342-248.138s72.668-4.371 113.545-41.751c38.503-35.162 45.373-103.395 45.373-103.395s102.71-18.08 203.606-18.08c2.48 0 4.958.013 7.434.034v420.168l348.966.602c-2.43 25.685-5.588 51.206-9.674 75.438-22.923 135.965-97.871 207.538-177.532 259.846z"/>'
  }
})
